import HttpClient from "../httpClient";
import { Login2FARequest, LoginRequest, LoginResponse } from "../../models/types/auth";

interface CsrfTokenResponse {
    token: string;
}
class AuthService {
    private service = HttpClient;

    async login(requestData: LoginRequest): Promise<LoginResponse> {
        const response = await this.service.post<LoginResponse>("/Account/Login", requestData, {
            withCredentials: true,
        });
        return response;
    }

    async login2FA(requestData: Login2FARequest): Promise<LoginResponse> {
        const response = await this.service.post<LoginResponse>("/Account/Login2FA", requestData, {
            withCredentials: true,
        });
        return response;
    }

    async getCsrfToken(): Promise<CsrfTokenResponse> {
        const response = await this.service.get<CsrfTokenResponse>('/security/csrf-token', {}, {
            withCredentials: true,
        });
        return response;
    }

    async getQR2FA(): Promise<any> {
        const response = await this.service.post('/Account/GetQR2FA');
        return response;
    }

    async enable2FA(data: {
        "verifyCode": string,
        "secretKey": string
    }): Promise<any> {
        const response = await this.service.post('/Account/Enable2FA', { ...data });
        return response;
    }
    //     // POST x-www-form-urlencoded
    // api.postParams('/login', { username: 'abc', password: 'xyz' });

    // // GET binary (e.g. download PDF)
    // api.getBinary('/download/report', { id: 123 }, 'blob').then((blob) => {
    //     const url = URL.createObjectURL(blob);
    //     window.open(url);
    // });

    // // POST binary FormData (e.g. upload file)
    // const formData = new FormData();
    // formData.append('file', fileInput.files[0]);
    // api.postBinary('/upload', formData);

    // // POST binary Blob (e.g. send binary data)
    // const blob = new Blob(['Hello world'], { type: 'text/plain' });
    // api.postBinary('/send/blob', blob);

}

const authSvc = new AuthService();
export default authSvc;
